import angular, { IQService, IWindowService } from 'angular';

import templateUrl from './payroll-invoice-list.component.html';
import { containsInvariant } from '../../../core/services/filter-util';
import { IcdCorporationService, LocaleService, PayrollInvoiceService, PayrollService } from '../../../core/services';
import { UtilityService } from '../../../core/services/utility.service';
import moment from 'moment';
import { StateService } from 'angular-ui-router';

const POSTED_INVOICE_STATUS_ID = 2;

export const PayrollInvoiceListComponent = {
    controller: PayrollInvoiceListController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        icdCorporationID: "<?",
        startDate: "<?",
        endDate: "<?"
    }
};

function PayrollInvoiceListController($q: IQService, $window: IWindowService, $state: StateService,
    localeService: LocaleService, hubService, icdCorporationService: IcdCorporationService,
    payrollService: PayrollService, payrollInvoiceService: PayrollInvoiceService,
    utilityService: UtilityService, apexApiUrl: string) {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = $onInit;

    vm.pageNumber = 1;
    vm.pageSize = 10;
    vm.loaded = false;
    vm.pendingUpdatesCount = null;
    vm.icdCorporationID;
    vm.startDateStr;
    vm.endDateStr;

    vm.icdCorporations;
    vm.icdCorporationSet = {};
    vm.selectedIcdCorporation;
    vm.startDate;
    vm.endDate;
    vm.payrolls;
    vm.rotations;
    vm.selectedRotation;
    vm.pristinePayrollInvoices;
    vm.payrollInvoices; // Used only to recompute the filtered payroll invoices without reload data.
    vm.filteredPayrollInvoices; // Used in the view and to compute the aggregates.
    vm.payrollInvoiceStatuses = [];
    vm.paymentMethods = [];
    vm.translations = {};
    vm.anyHJEmployees = false;
    vm.anyHubs = false;
    vm.anyOwners = false;

    vm.filters;
    vm.filterInvoice = filterInvoice;
    vm.updateInvoiceCalculations = updateInvoiceCalculations;
    vm.exportAllXlsx = exportAllXlsx;
    vm.onChangeIcdCorporation = onChangeIcdCorporation;
    vm.onChangeRotation = onChangeRotation;
    vm.onChangePaymentMethod = onChangePaymentMethod;
    vm.onSavePayrollInvoice = onSavePayrollInvoice;
    vm.anyDirty = anyDirty;
    vm.allPosted = allPosted;
    vm.onSaveAll = onSaveAll;
    vm.onCancel = onCancel;
    vm.onPostAllClick = onPostAllClick;
    vm.onChangeFilters = onChangeFilters;

    function $onInit() {
        utilityService.showLoading();

        if (vm.startDateStr) {
            vm.startDate = Date.parse(vm.startDateStr);
        }
        if (vm.endDateStr) {
            vm.endDate = Date.parse(vm.endDateStr);
        }
        vm.filters = {
            onlyPosted: false,
            onlyWithBalance: true,
            onlyBlankPaymentMethod: false
        };

        const getStatuses = payrollInvoiceService.retrievePayrollInvoiceStatuses()
            .then(function (statuses) {
                vm.payrollInvoiceStatuses = statuses;
                return statuses;
            });
        const getPaymentMethods = payrollInvoiceService.retrievePaymentMethods()
            .then(function (methods) {
                vm.paymentMethods = methods;
                return methods;
            });

        const getTranslations = localeService.retrieveCurrentLocale()
            .then(function (locale) {
                if (locale) {
                    return localeService.retrieveLocaleTranslations(locale.localeID);
                }
            })
            .then(function (translations) {
                vm.translations = translations;
                return vm.translations;
            })
            .catch(function (ex) {
                console.error("Translations lookup failed: " + utilityService.getExceptionMessage(ex));
                vm.translations = {};
                return vm.translations;
            });

        const hubsLoaded = hubService.retrieveHubs()
            .then(function (hubs) {
                vm.hubs = hubs;
                return vm.hubs;
            });

        const loadIcdCorporation = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Invoices")
            .then(function (corporations) {
                vm.icdCorporations = corporations || [];
                return vm.icdCorporations;

            }).then(loadDefaultCorporation);

        loadIcdCorporation
            .then(loadPayrolls)
            .then(function () {
                vm.startDate = vm.selectedPayroll ? vm.selectedPayroll.StartDate : vm.startDate;
                vm.endDate = vm.selectedPayroll ? vm.selectedPayroll.EndDate : vm.endDate;
                return loadPayrollInvoices(vm.icdCorporationID, vm.startDate, vm.endDate);
            })
            .then(initializeInvoicesWith(getStatuses, getPaymentMethods, getTranslations, hubsLoaded))
            .then(function () {
                utilityService.hideLoading();
                vm.loaded = true;
                updatePageState();
            })
            .catch(function (ex) {
                const msg = "Initial load failed: " + utilityService.getExceptionMessage(ex);
                console.error(msg);
                alert(msg);
            });
    }

    function selectDefaultRotation(payrolls, startDate, endDate) {
        if (startDate != null && endDate != null) {
            const payroll = payrolls.filter(function (payroll) {
                return moment(payroll.EndDate).isSame(endDate, 'day') && moment(payroll.StartDate).isSame(startDate, 'day')
            })[0];
            if (!payroll && payrolls[0]) {
                vm.startDate = payrolls[0].StartDate;
                vm.endDate = payrolls[0].EndDate;
                return payrolls[0]
            }
            return payroll;

        } else {
            return payrolls[0];
        }
    }


    function loadDefaultCorporation(corporations) {
        if (corporations.length === 1) {
            // If there is only one corporation, select it automatically.
            vm.selectedIcdCorporation = corporations[0];
        } else {
            // Ok if there is no default selection when the filter doesn't match.
            vm.selectedIcdCorporation = corporations.filter(function (corporation) {
                return corporation.Id === vm.icdCorporationID;
            })[0];
        }

        if (vm.selectedIcdCorporation) {
            vm.icdCorporationID = vm.selectedIcdCorporation.Id;
        } else {
            vm.icdCorporationID = null;
        }

        updatePageState();
        return vm.selectedIcdCorporation;
    }

    function onChangeIcdCorporation(icdCorporation) {
        utilityService.showLoading();
        vm.startDate = null;
        vm.endDate = null;
        vm.payrolls = [];

        if (icdCorporation) {
            vm.icdCorporationID = icdCorporation.Id;
            if (!icdCorporation.Id) {
                vm.selectedIcdCorporation = null;
            }
        } else {
            vm.icdCorporationID = null;
        }

        loadPayrolls()
            .then(function () {
                vm.startDate = vm.selectedPayroll ? vm.selectedPayroll.StartDate : vm.startDate;
                vm.endDate = vm.selectedPayroll ? vm.selectedPayroll.EndDate : vm.endDate;
                return loadPayrollInvoices(vm.icdCorporationID, vm.startDate, vm.endDate);
            }).then(initializeInvoicesWith(vm.payrollInvoiceStatuses, vm.paymentMethods, vm.translations))
            .catch(angular.noop)
            .then(function () {
                utilityService.hideLoading();
                updatePageState();
                vm.pendingUpdatesCount = null;
            });
    }

    function onChangeRotation(rotation) {
        utilityService.showLoading();
        if (rotation) {
            vm.startDate = rotation.StartDate;
            vm.endDate = rotation.EndDate;
        } else {
            vm.startDate = null;
            vm.endDate = null;
        }

        return loadPayrollInvoices(vm.icdCorporationID, vm.startDate, vm.endDate)
            .then(initializeInvoicesWith(vm.payrollInvoiceStatuses, vm.paymentMethods, vm.translations))
            .catch(angular.noop)
            .then(function () {
                utilityService.hideLoading()
                updatePageState();
                vm.pendingUpdatesCount = null;
            });
    }

    function onChangePaymentMethod(invoice) {
        invoice.dirty = true;
        invoice.PaymentMethod = vm.paymentMethods.filter(function (method) {
            return method.Value === invoice.PaymentMethodID;
        })[0];
    }

    function onSavePayrollInvoice(invoice) {
        vm.pendingUpdatesCount++;
        savePayrollInvoice(invoice)
            .then(function () {
                calculateAggregateData(vm.payrollInvoices);
            })
            .catch(function (ex) {
                alert("Saving failed: " + utilityService.getExceptionMessage(ex))
            })
            .then(function () {
                vm.pendingUpdatesCount--;
            });
    }

    function filterInvoice(invoice) {
        return invoice.dirty || (!vm.filters.onlyWithBalance || invoice.TotalDue !== 0)
            && (!vm.filters.onlyPosted || invoice.StatusID === POSTED_INVOICE_STATUS_ID)
            && (!vm.filters.onlyBlankPaymentMethod || !invoice.PaymentMethodID)
            && (!vm.filters.checkDate || moment(vm.filters.checkDate).isBetween(invoice.StartDate, invoice.EndDate, 'days', '[]'))
            && (!vm.filters.invoiceStartDate || moment(vm.filters.invoiceStartDate).isSameOrBefore(invoice.InvoiceDate))
            && (!vm.filters.invoiceEndDate || moment(vm.filters.invoiceEndDate).isSameOrAfter(invoice.InvoiceDate))

            && (!vm.filters.payFrequency || containsInvariant(invoice.PayFrequency, vm.filters.payFrequency))
            && (!vm.filters.division || containsInvariant(invoice.Division,
                vm.filters.division))
            && (!vm.filters.hub || containsInvariant(invoice.Hub, vm.filters.hub))
            && (!vm.filters.owner || containsInvariant(invoice.Owner, vm.filters.owner))
            && (!vm.filters.clientName || containsInvariant(invoice.ClientName, vm.filters.clientName))
            && (!vm.filters.stateProvinceName || containsInvariant(
                invoice.StateProvince, vm.filters.stateProvinceName))
            && (!vm.filters.countryName || containsInvariant(
                invoice.CountryName, vm.filters.countryName))
            && (!vm.filters.invoiceNumber || containsInvariant(String(invoice.InvoiceNumber), vm.filters.invoiceNumber))
            && (!vm.filters.paymentMethod || invoice.PaymentMethod
                && containsInvariant(invoice.PaymentMethod.Text, vm.filters.paymentMethod))
            && (!vm.filters.hjComments || containsInvariant(String(invoice.HJComments), vm.filters.hjComments))
            && (!vm.filters.hubComments || containsInvariant(String(invoice.HubComments), vm.filters.hubComments))
            && (!vm.filters.ownerComments || containsInvariant(String(invoice.OwnerComments), vm.filters.ownerComments))
            && !vm.filters.officeDistributionCode;
    }

    function sortInvoices(payrollInvoices) {
        return payrollInvoices.sort(function (a, b) {
            if (a.ClientName !== b.ClientName) {
                return a.ClientName < b.ClientName ? -1 : 1;
            }
            if (a.Owner !== b.Owner) {
                return a.Owner < b.Owner ? -1 : 1;
            }
            // Sort by payroll date in descending order.
            return a.StartDate < b.StartDate ? 1 : -1;
        });
    }

    function savePayrollInvoice(invoice) {
        return payrollInvoiceService.updatePayrollInvoice(invoice.PayrollID, invoice)
            .then(function (invoice) {
                // Replace the invoice in both the pristine list and working list with this invoice.
                vm.pristinePayrollInvoices[vm.pristinePayrollInvoices.reduce(function (index, pristineInvoice, i) {
                    return pristineInvoice.PayrollID === invoice.PayrollID ? i : index;
                }, null)] = angular.copy(invoice);

                return loadPayrollInvoiceData(invoice, vm.payrollInvoiceStatuses,
                    vm.paymentMethods, vm.translations, vm.hubs);
            })
            .then(function (invoice) {
                vm.payrollInvoices[vm.payrollInvoices.reduce(function (index, dirtyInvoice, i) {
                    return dirtyInvoice.PayrollID === invoice.PayrollID ? i : index
                }, null)] = invoice;

                vm.filteredPayrollInvoices[vm.filteredPayrollInvoices.reduce(function (index, dirtyInvoice, i) {
                    return dirtyInvoice.PayrollID === invoice.PayrollID ? i : index
                }, null)] = invoice;
            });
    }

    function loadPayrolls() {
        const query = {
            icdCorporationID: vm.icdCorporationID as number
        }
        const loadPayrolls = payrollService.retrieveRotations(query)
            .then(function (rotations: any) {
                rotations.forEach(function (rotation, i) {
                    rotation.PayrollID = i; // Used in the payroll select component to identify the selected payroll.
                });
                vm.payrolls = rotations;
                return vm.payrolls;
            })
            .then(function () {
                vm.payrolls = vm.payrolls.sort(function (a, b) {
                    if (a.StartDate < b.StartDate) {
                        return 1;
                    } else if (a.StartDate > b.StartDate) {
                        return -1;
                    }
                    if (a.EndDate < b.EndDate) {
                        return 1;
                    }
                    if (a.EndDate < b.EndDate) {
                        return -1;
                    }
                    return 0;
                });
                return vm.payrolls;
            })
            .then(function (payrolls) {
                vm.selectedPayroll = selectDefaultRotation(vm.payrolls, vm.startDate, vm.endDate);
                return vm.selectedPayroll;
            });

        return loadPayrolls;
    }

    function loadPayrollInvoices(icdCorporationID, startDate, endDate) {
        const query = {
            IcdCorporationID: icdCorporationID,
            StartDate: startDate ? moment(startDate).format("YYYY-MM-DD") : startDate,
            EndDate: endDate ? moment(endDate).format("YYYY-MM-DD") : endDate,
            MatchExactPayrollDate: true
        };

        return payrollInvoiceService.retrievePayrollInvoices(query)
            .then(function (payrollInvoices) {
                vm.pristinePayrollInvoices = payrollInvoices;
                return angular.copy(vm.pristinePayrollInvoices);
            });
    }

    function calculateAggregateData(payrollInvoices) {
        vm.anyHJEmployees = false;
        vm.anyHubs = false;
        vm.anyOwners = false;
        vm.anyTaxRate1 = false;
        vm.anyTaxRate2 = false;
        vm.anyTaxRate3 = false;
        vm.totals = {
            postedCount: 0,
            postableCount: 0,
            blankPaymentMethodCount: 0,
            flatFee: 0,
            totalTaxAmount: 0,
            totalDue: 0
        };
        vm.totals.FlatFee = 0;
        vm.totals.Adjustment = 0;
        vm.totals.Subtotal = 0;
        vm.totals.TaxAmount1 = 0;
        vm.totals.TaxAmount2 = 0;
        vm.totals.TaxAmount3 = 0;
        vm.totals.TotalDue = 0;
        vm.totals.NumberOfEmployeesProcessed = 0;

        payrollInvoices.forEach(function (invoice) {
            vm.anyHJEmployees = vm.anyHJEmployees || invoice.IsHJEmployee;
            vm.anyHubs = vm.anyHubs || invoice.IsHub;
            vm.anyOwners = vm.anyOwners || invoice.IsOwner;
            vm.anyTaxRate1 = vm.anyTaxRate1 || invoice.TaxRate1 !== null;
            vm.anyTaxRate2 = vm.anyTaxRate2 || invoice.TaxRate2 !== null;
            vm.anyTaxRate3 = vm.anyTaxRate3 || invoice.TaxRate3 !== null;

            if (vm.filterInvoice(invoice)) {
                // Only aggregate the totals and averages if the invoice is visible.
                if (invoice.StatusID === POSTED_INVOICE_STATUS_ID) {
                    vm.totals.postedCount += 1;
                }
                if (invoice.TotalDue !== 0) {
                    vm.totals.postableCount += 1;
                    vm.totals.flatFee += invoice.FlatFee;
                    vm.totals.totalTaxAmount += invoice.TotalTaxAmount;
                    vm.totals.totalDue += invoice.TotalDue;
                }
                if (!invoice.PaymentMethodID) {
                    vm.totals.blankPaymentMethodCount += 1;
                }

                vm.totals.FlatFee += invoice.NumberOfEmployeesProcessed > 0 && invoice.FlatFee || 0;
                vm.totals.Adjustment += invoice.Adjustment || 0;
                vm.totals.NumberOfEmployeesProcessed += invoice.NumberOfEmployeesProcessed || 0;
                vm.totals.Subtotal += invoice.Subtotal || 0;
                vm.totals.TaxAmount1 += invoice.TaxAmount1 || 0;
                vm.totals.TaxAmount2 += invoice.TaxAmount2 || 0;
                vm.totals.TaxAmount3 += invoice.TaxAmount3 || 0;
                vm.totals.TotalDue += invoice.TotalDue || 0;
            }
        });
    }

    function loadPayrollInvoiceData(invoice, statuses, paymentMethods, translations, hubs) {

        // Look up the invoice status and payment method in the list.
        invoice.Status = statuses.filter(function (status) {
            return status.Value === invoice.StatusID;
        })[0];
        invoice.PaymentMethod = paymentMethods.filter(function (method) {
            return method.Value === invoice.PaymentMethodID;
        })[0];

        const appliedTaxes = [];
        if (invoice.TaxRate1) {
            appliedTaxes.push({ Label: translations.TaxRate1_Label, Rate: invoice.TaxRate1 });
        }
        if (invoice.TaxRate2) {
            appliedTaxes.push({ Label: translations.TaxRate2_Label, Rate: invoice.TaxRate2 });
        }
        if (invoice.TaxRate3) {
            appliedTaxes.push({ Label: translations.TaxRate3_Label, Rate: invoice.TaxRate3 });
        }
        invoice.taxHint = appliedTaxes.map(function (taxLabel) {
            // Handle floating point errors that would be introduced by simply multiplying by 100.
            // eg, 7 * 100
            const ratePercent = Math.round(taxLabel.Rate * 100000) / 1000;
            return kendo.format("{0:0.###}% {1}", ratePercent, taxLabel.Label);
        }).join(" + ");

        return invoice;
    }

    function updatePageState() {
        const pageParams: any = {};
        if (vm.icdCorporationID) {
            pageParams.icdCorporationID = vm.icdCorporationID;
        }
        if (vm.startDate) {
            pageParams.startDate = vm.startDate;
        }
        if (vm.endDate) {
            pageParams.endDate = vm.endDate;
        }
        $state.go(".", pageParams, { location: "replace" });
    }

    function updateInvoiceCalculations(invoice) {
        invoice.Subtotal = Math.max((invoice.NumberOfEmployeesProcessed > 0 && invoice.FlatFee || 0)
            + (invoice.Adjustment || 0), 0);
        invoice.TaxAmount1 = (invoice.TaxRate1 || 0) * invoice.Subtotal;
        invoice.TaxAmount2 = (invoice.TaxRate2 || 0) * invoice.Subtotal;
        invoice.TaxAmount3 = (invoice.TaxRate3 || 0) * invoice.Subtotal;
        invoice.TotalTaxAmount = invoice.TaxAmount1 + invoice.TaxAmount2 + invoice.TaxAmount3;
        invoice.TotalDue = invoice.Subtotal + invoice.TotalTaxAmount;

        invoice.dirty = true;

        calculateAggregateData(vm.payrollInvoices);
    }

    function exportAllXlsx() {
        const args: any = {};
        if (vm.icdCorporationID) {
            args.IcdCorporationID = vm.icdCorporationID;
        }
        if (vm.startDate) {
            args.StartDate = moment(vm.startDate).format("YYYY-MM-DD");
        }
        if (vm.endDate) {
            args.EndDate = moment(vm.endDate).format("YYYY-MM-DD");
        }
        if (vm.filters && vm.filters.invoiceStartDate) {
            args.InvoiceStartDate = moment(vm.filters.invoiceStartDate).format("YYYY-MM-DD");
        }
        if (vm.filters && vm.filters.invoiceEndDate) {
            args.InvoiceEndDate = moment(vm.filters.invoiceEndDate).format("YYYY-MM-DD");
        }
        args.MatchExactPayrollDate = true;
        const queryString = Object.keys(args).reduce(function (query, key) {
            return (query ? query + "&" : "?") + key + "=" + args[key];
        }, "");

        $window.location.href = $window.encodeURI(apexApiUrl + "/payroll-invoice-export-all.xlsx" + queryString);
    }

    function anyDirty() {
        return vm.payrollInvoices.reduce(function (any, invoice) {
            return any || !!invoice.dirty;
        }, false)
    }

    function allPosted() {
        return vm.payrollInvoices
            .filter(vm.filterInvoice)
            .reduce(function (all, invoice) {
                return all && (invoice.StatusID === POSTED_INVOICE_STATUS_ID
                    || vm.filters.onlyWithBalance && !invoice.dirty && invoice.TotalDue === 0);
            }, true);
    }

    function onPostAllClick() {
        const value = allPosted() ? 1 : 2;
        vm.payrollInvoices
            .filter(vm.filterInvoice)
            .forEach(function (invoice) {
                if (invoice.StatusID !== value && (!vm.filters.onlyWithBalance
                    || invoice.dirty || invoice.TotalDue !== 0)) {
                    invoice.StatusID = value;
                    invoice.dirty = true;
                }
            });
    }

    function onSaveAll() {
        vm.pendingUpdatesCount++;

        const savedPayrolls = vm.payrollInvoices.filter(function (invoice) {
            return invoice.dirty;
        }).map(savePayrollInvoice);

        $q.all(savedPayrolls)
            .then(function () {
                calculateAggregateData(vm.payrollInvoices);
            })
            .catch(function (ex) {
                alert("Saving failed: " + utilityService.getExceptionMessage(ex))
            })
            .then(function () {
                vm.pendingUpdatesCount--;
            });
    }

    function onCancel() {
        $q.when(angular.copy(vm.pristinePayrollInvoices))
            .then(initializeInvoicesWith(vm.payrollInvoiceStatuses, vm.paymentMethods, vm.translations));
    }

    function onChangeFilters() {
        vm.filteredPayrollInvoices = vm.payrollInvoices.filter(vm.filterInvoice)
        calculateAggregateData(vm.payrollInvoices);
    }

    /**
     * Return a function that resolves with the given statuses, payment methods, and translations
     * and initalizes the invoices passed as its argument.
     */
    function initializeInvoicesWith(payrollInvoiceStatuses, paymentMethods, translations, hubs?) {
        return function (invoices) {
            return $q.all([payrollInvoiceStatuses, paymentMethods, translations, hubs])
                .then(function (v) {
                    const payrollInvoiceStatuses = v[0] || [];
                    const paymentMethods = v[1] || [];
                    const translations = v[2] || {};
                    const hubs = v[3] || [];

                    return initializeInvoices(invoices, payrollInvoiceStatuses,
                        paymentMethods, translations, hubs);
                });
        }
    }

    /**
     * Load the given list of invoices with the statuses, payment methods, and translations data given.
     */
    function initializeInvoices(invoices, payrollInvoiceStatuses, paymentMethods, translations, hubs) {
        return $q.all(invoices.map(function (invoice) {
            return loadPayrollInvoiceData(invoice, payrollInvoiceStatuses, paymentMethods, translations, hubs);
        }))
            .then(sortInvoices)
            .then(function (invoices) {
                vm.payrollInvoices = invoices;

                return vm.payrollInvoices;
            })
            .then(function (invoices) {
                // Initialize the list of filtered invoices.
                vm.filteredPayrollInvoices = invoices.filter(vm.filterInvoice);

                return vm.payrollInvoices;
            })
            // The filter is performed again in the aggregator in order to calculate some values based on hidden invoices.
            .then(calculateAggregateData);
    }
}
